import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useField } from "@madmedical/form";
import { Box } from "native-base";
import BaseTimeInput from "../molecules/Form/TimeInput";
import useResponsive from "../util/useResponsive";
const TimeInput = ({ name, isRequired, label, previousTime }) => {
    const { control, isError, error } = useField(name);
    const { isSmallScreen } = useResponsive();
    return (_jsx(Box, Object.assign({ width: isSmallScreen ? "auto" : 170 }, { children: _jsx(Controller, { name: name, control: control, rules: { required: isRequired }, render: ({ field: { onChange, value } }) => {
                const time = value ? new Date(value) : new Date();
                const hoursAndMinutes = `0${time.getHours()}`.slice(-2) +
                    ":" +
                    `0${time.getMinutes()}`.slice(-2);
                const convertChange = (time) => {
                    const hours = parseInt(time.split(":")[0], 10);
                    const minutes = parseInt(time.split(":")[1], 10);
                    const now = previousTime
                        ? new Date(previousTime)
                        : new Date();
                    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0)
                        .toTimeString()
                        .replace(/\s\(.+?\)/, "");
                    onChange(date);
                };
                return (_jsx(BaseTimeInput, { onChange: convertChange, value: hoursAndMinutes, label: label, isInvalid: isError, error: error }));
            } }) })));
};
export default TimeInput;
